import { useCallback, useState } from 'react';

import type { TipoCompartilhavel } from '@/api/compartilhamento';
import { useVisaoDoEscritorio } from '@/hooks/useVisaoDoEscritorio';

import { CompartilharNoEscritorioDialog } from './CompartilharNoEscritorioDialog';

interface Alvo {
  tipo: TipoCompartilhavel;
  id: string;
  rotulo: string;
}

/**
 * O "Compartilhar no escritório…" de uma lista: ``podeCompartilhar`` diz se a ação aparece
 * (quem é de um escritório, fora da delegação — o acervo do titular não é de quem atua por
 * ele), ``abrir`` mostra o diálogo do item, e ``dialogo`` vai uma vez na tela.
 */
export function useCompartilharNoEscritorio() {
  // Também quem entra pela assinatura do escritório: decide sobre o próprio acervo (§18).
  const podeCompartilhar = useVisaoDoEscritorio();
  const [alvo, setAlvo] = useState<Alvo | null>(null);
  const [aberto, setAberto] = useState(false);
  const abrir = useCallback((tipo: TipoCompartilhavel, id: string, rotulo: string) => {
    setAlvo({ tipo, id, rotulo });
    setAberto(true);
  }, []);
  const dialogo = alvo ? (
    <CompartilharNoEscritorioDialog
      open={aberto}
      onOpenChange={setAberto}
      tipo={alvo.tipo}
      recursoId={alvo.id}
      rotulo={alvo.rotulo}
    />
  ) : null;
  return { podeCompartilhar, abrir, dialogo };
}
